import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { AllDeviceInfo } from '@interfaces';
import { DeviceInfoService } from '@core/services/device-info.service';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IntroModalComponent } from './intro-modal.component';

export enum MODAL_MESSAGE {
  USER_WELCOME = 'USER_WELCOME',
  PERSONAL_DETAILS_INSTRUCTIONS = 'PERSONAL_DETAILS_INSTRUCTIONS',
  DOCUMENTS_INSTRUCTIONS = 'DOCUMENTS_INSTRUCTIONS',
  UNFINISHED_DOCUMENT_STEP = 'UNFINISHED_DOCUMENT_STEP',
  VERIFICATION_DOCS_INFO = 'VERIFICATION_DOCS_INFO',
  SUMMARY_BASIC_INSTRUCTIONS = 'SUMMARY_BASIC_INSTRUCTIONS',
  SUMMARY_ASSISTANT_INSTRUCTIONS = 'SUMMARY_ASSISTANT_INSTRUCTIONS',
}

export interface ModalOpts {
  messageKey: MODAL_MESSAGE;
  showActionButtons: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class IntroModalService implements OnDestroy {
  private readonly dialog = inject(MatDialog);
  private readonly deviceInfoService = inject(DeviceInfoService);
  private readonly mobileDialogWidth = 'calc(100vw - 32px)';
  private readonly mobileDialogMaxHeight = 'calc(100dvh - 32px)';

  public dialogRef: MatDialogRef<any>;
  public name = 'intro-modal';

  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public deviceInfo: AllDeviceInfo;
  private dialogWidth = '850px';

  constructor() {
    this.deviceInfo = this.deviceInfoService.getInfo();
    this.deviceInfoService.infoEmitter.pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.deviceInfo = info;
      if (this.deviceInfo.deviceTypeDetected === 'PHONE') {
        this.dialogWidth = this.mobileDialogWidth;
      }
    });
    if (this.deviceInfo.deviceTypeDetected === 'PHONE') {
      this.dialogWidth = this.mobileDialogWidth;
    }
  }

  public open(opts: ModalOpts): MatDialogRef<IntroModalComponent> {
    const isPhone = this.deviceInfo.deviceTypeDetected === 'PHONE';

    this.dialogRef = this.dialog.open(IntroModalComponent, {
      width: this.dialogWidth,
      maxWidth: this.dialogWidth,
      ...(isPhone ? { maxHeight: this.mobileDialogMaxHeight } : {}),
      panelClass: ['intro-modal'],
      data: { ...opts },
      autoFocus: false,
      backdropClass: ['user-process-modal-backdrop', this.name + '_backdrop'],
    });

    return this.dialogRef;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
